import { areFieldValuesEqual } from '../../utils/fieldUtils';
import FormField from './FormField';
import { useFormState } from 'react-final-form';

const FieldGroup = ({ data, breadCrumbs }) => {
  const { values: formValues } = useFormState();

  const findFieldValue = (fieldName) => {
    if (!formValues) return null;

    if (formValues[fieldName] !== undefined) {
      return formValues[fieldName];
    }

    const values = [];

    for (const key in formValues) {
      const group = formValues[key];
      if (!Array.isArray(group)) continue;

      for (const item of group) {
        if (item?.[fieldName] !== undefined) {
          values.push(item[fieldName]);
        }
      }
    }

    return values.length > 0 ? values : null;
  };

  const compareFieldValue = (fieldName, compareValue) => {
    const value = findFieldValue(fieldName);
    return areFieldValuesEqual(value, compareValue);
  };

  const { headerText, textCssClass, cssClass, fields, hideExpression } = data;

  // Evaluate hide expressions
  if (hideExpression) {
    let rules = [];
    try {
      rules = JSON.parse(hideExpression);
    } catch {
      // ignore
    }

    for (const rule of rules || []) {
      if (rule?.fieldName && rule?.value !== undefined) {
        const cmp = compareFieldValue(rule.fieldName, rule.value);
        if (cmp) {
          return null;
        }
      }
    }
  }

  return (
    <div className={`main ${cssClass ? ' ' + cssClass : ''}`}>
      {headerText && <h4 className={textCssClass}>{headerText}</h4>}
      {headerText && <div className="clearfix" />}
      {fields.map((field, index) => {
        // Hide logic
        if (field.hideExpression) {
          let rules = [];
          try {
            rules = JSON.parse(field.hideExpression);
          } catch {
            // ignore invalid JSON
          }
          for (const rule of rules || []) {
            if (rule?.fieldName && rule?.value !== undefined) {
              if (compareFieldValue(rule.fieldName, rule.value)) {
                return null;
              }
            }
          }
        }
        // Show logic
        if (field.showExpression) {
          let rules = [];
          try {
            rules = JSON.parse(field.showExpression);
          } catch {
            // ignore invalid JSON
          }
          let show = false;
          for (const rule of rules || []) {
            if (rule?.fieldName && rule?.value !== undefined) {
              if (compareFieldValue(rule.fieldName, rule.value)) {
                show = true;
                break;
              }
            }
          }
          if (!show) return null;
        }
        // eslint-disable-next-line @eslint-react/no-array-index-key
        return <FormField key={index} data={field} parent={data} hasManyRow={null} breadCrumbs={breadCrumbs} />;
      })}
    </div>
  );
};

export default FieldGroup;
